export function activateProductInfoTab(tabId: string): boolean {
  const radio = document.getElementById(
    `tab-${tabId}`
  ) as HTMLInputElement | null;
  if (!radio) return false;
  radio.checked = true;
  return true;
}

export function navigateToProductInfoTab(tabId: string) {
  if (typeof window === 'undefined') return;

  window.location.hash = tabId;
  activateProductInfoTab(tabId);
  document.getElementById(tabId)?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
}
